"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  primary: {
    rgb: "rgb(34,15,37)",
    rgba: "rgba(34,15,37,1)",
    hex: "#201024"
  },
  secondary: {
    rgb: "rgb(238,73,92)",
    rgba: "rgba(238,73,92,1)",
    hex: "#EE495C"
  },
  tertiary: {
    rgb: "rgb(114,99,113)",
    rgba: "rgba(114,99,113,1)",
    hex: "#726371"
  },
  medium: {
    rgb: "rgb(170,164,171)",
    rgba: "rgba(170,164,171,1)",
    hex: "#AAA4AB"
  },
  subdued: {
    rgb: "rgb(243,242,243)",
    rgba: "rgba(243,242,243,1)",
    hex: "#F3F2F3"
  }
};
exports["default"] = _default;